import React, { useState } from "react";
import Loader from "../pages/Loader";
const useLoader = () => {
    const [loaderConfig, setLoaderConfig] = useState({
        show:false,
        text:'loading...'
    });
    return [
        loaderConfig?.show ? <Loader text={loaderConfig?.text} /> : null,
        (text) => setLoaderConfig({show:true,text:text}),
        () => setLoaderConfig({show:false,text:'loading...'}),
    ];
};
export default useLoader;
